import { createSelector } from 'reselect';

const trainingsData = (state) => state.trainingsData;

export const selectFilterData = () => createSelector([trainingsData], (state) => state.filter);

export const selectFilterCriteriaData = () =>
  createSelector([trainingsData], (state) => state.filterCriteria);
